import { Component, Input } from '@angular/core'
import { AppStateService } from 'src/app/core/services/app-state.service'

@Component({
  selector: 'app-reporting-mode-indicator',
  templateUrl: './reporting-mode-indicator.component.html',
  standalone: false,
})
export class ReportingModeIndicatorComponent {
  @Input() isReportingActive = false

  constructor(public appState: AppStateService) {}
}
